import { render, staticRenderFns } from "./listadoMaterial.vue?vue&type=template&id=33a62739"
import script from "./listadoMaterial.vue?vue&type=script&lang=js"
export * from "./listadoMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports